package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class StudentWithSubjectEnrollmentsCreateRequest(
    @SerialName("school_id") val schoolId: String,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("admission_number") val admissionNumber: String,
    @SerialName("roll_number") val rollNumber: String? = null,
    val name: String,
    val dob: String,
    val gender: String,
    @SerialName("blood_group") val bloodGroup: String? = null,
    @SerialName("custom_attributes") val customAttributes: Map<String, JsonElement>? = null,
    @EncodeDefault
    @SerialName("is_active") val isActive: Boolean = true,
    @SerialName("class_subject_link_ids") val classSubjectLinkIds: List<String> = emptyList()
)

@Serializable
data class StudentUpdateRequest(
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("class_name") val className: String? = null,
    @SerialName("section_name") val sectionName: String? = null,
    @SerialName("admission_number") val admissionNumber: String? = null,
    @SerialName("roll_number") val rollNumber: String? = null,
    val name: String? = null,
    val dob: String? = null,
    val gender: String? = null,
    @SerialName("blood_group") val bloodGroup: String? = null,
    @SerialName("custom_attributes") val customAttributes: Map<String, JsonElement>? = null,
    @SerialName("is_active") val isActive: Boolean? = null
)

@Serializable
data class StudentToggleStatusRequest(
    @SerialName("is_active") val isActive: Boolean
)

@Serializable
data class StudentSubjectEnrollmentCreateRequest(
    @SerialName("student_id") val studentId: String,
    @SerialName("class_subject_link_id") val classSubjectLinkId: String,
    @EncodeDefault
    @SerialName("is_active") val isActive: Boolean = true
)
